import PageHeader from "../components/PageHeader";
import { Box, Text } from "@chakra-ui/react";

const Settings = () => {
  return (
    
    <Box p={6}>
      <PageHeader
        title="Settings"
        subtitle="Manage your application Settings."
        
      />
      <Text fontSize="md" color="gray.600">
        This is the Settings page. Configure app preferences here.
      </Text>
    </Box>
    
  );
};

export default Settings;
